<script>
export default {
  data() {
    return {
      bioacoustic_url: '/static/bioacoustic-demo.html',
    };
  },
};
</script>

<template>
  <div style="height: 100%; width: 100%;">
    <b-row class="app-section">
      <b-col cols="12" class="bio-acoustic-section">
        <b-container>
          <b-row class="title">
            <b-col cols="12">
              <h4>Bio-Acoustic Sonar Demonstration</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <p>
                This is a demonstration visualization of complex acoustic data
                on the Interactive Oceans Data Portal. The images seen below
                are examples of interactive plots of bio-acoustic sonar data
                that allows users to zoom in on the plot, download images, and
                shift the graph. The color scale indicates the intensity of the
                echo return from the multi-frequency sonar pings sent out by
                the instrument, which allows scientists to track biological
                activity in the water column. The final version will allow
                users to create similar plots via the “Visualize Data” page,
                providing access to data from a variety of different active and
                passive acoustic instruments deployed on the OOI Regional
                Cabled Array
              </p>
            </b-col>
          </b-row>
          <b-row class="bio-acoustic-iframe" align-v="center" style="height: 100%; width: 100%">
            <b-col cols="12" style="height: 100%;">
              <b-embed
                type="iframe"
                aspect="4by3"
                :src="`${bioacoustic_url}`"
                allowfullscreen></b-embed>
              <br />
            </b-col>
          </b-row>
          <br />
        </b-container>
      </b-col>
    </b-row>
  </div>
</template>
<style>
.title {
  margin-top: 20px;
  font-size: 20px;
}
.bio-acoustic-iframe {
  border: 0.5px solid black;
}
</style>
